import { createTransform } from 'redux-persist'
import { DeadLetterEventsState, initialState } from './deadLetterEventsSlice'
import { RootState } from '../../types/RootState'

export const transformer = createTransform<
  DeadLetterEventsState,
  Omit<DeadLetterEventsState, 'error'>,
  RootState
>(
  inboundState => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { error, ...persistedState } = inboundState
    return persistedState
  },
  outboundState => {
    const status: DeadLetterEventsState['status'] =
      outboundState.status === 'initial' ? outboundState.status : 'idle'
    return {
      ...outboundState,
      error: initialState.error,
      status,
    }
  },
  {
    whitelist: ['deadLetterEvents'],
  },
)
